import React from "react";
import Html from "./Html";
import { Provider } from "./Provider";
const Invoices = () => {
    return(
        <Provider>
            <Html/>
        </Provider>
    )
} 
export default Invoices;